import { ComponentType as h } from "../../registries/types/propTypes.js";
const m = (i) => {
  const t = (Array.isArray(i.amway_highlights) ? i.amway_highlights[0] : i.amway_highlights).items.map((a) => ({
    images: a.image.images,
    description: a.description,
    title: a.title
  }));
  return {
    componentType: h.amway_highlights,
    amwayHighlightsData: t
  };
};
export {
  m as default
};
//# sourceMappingURL=amway-highlights-transformer.js.map
